// No imports: the merge-field placeholders, the token utils and the view models all read these, and the view
// models can't import the models barrel.

export const FileRequestMergeFieldSymbols = ['{{file request}}', '{{fileRequest}}', '{{fileRequestLink}}'];
export const FileRequestMergeFieldValue = 'survey.fileRequestLink';

export const FileSendMergeFieldSymbols = [
	'{{send files}}',
	'{{sendfiles}}',
	'{{download files}}',
	'{{downloadfiles}}',
	'{{file download}}',
	'{{filedownload}}',
];
export const FileSendMergeFieldValue = 'fileDownloadLink';

// A chip stays as its placeholder span when a preceding chip stops Token.replaceToken from converting it back to
// its symbol, and the API accepts both forms, so either counts.
const asksFor = (text: string | null | undefined, symbols: string[], value: string) =>
	!!text && (symbols.some(symbol => text.includes(symbol)) || text.includes(`data-placeholder-value="${value}"`));

export const textRequestsFiles = (text: string | null | undefined) =>
	asksFor(text, FileRequestMergeFieldSymbols, FileRequestMergeFieldValue);

export const textSendsFiles = (text: string | null | undefined) =>
	asksFor(text, FileSendMergeFieldSymbols, FileSendMergeFieldValue);
